import "./Footer.scss";

const Footer = ({ children }) => {
  return <div className="Footer">{children}</div>;
};

export default Footer;
